export const Slider = {
  parts: ['container', 'thumb', 'track', 'filledTrack'],

  baseStyle: {
    container: {},
    thumb: {
      bg: 'brand.green',
    },
    track: {
      bg: 'brand.lightgreen',
    },
    filledTrack: {
      bg: 'brand.green',
    },
  },
};
